import 'uni-pages';import 'uni-h5';import App from './App'

import { router, RouterMount } from '@/router/router.js'
Vue.use(router);

import sk from '@/common/sk.js';
Vue.prototype.$sk = sk;

let vuexStore = require("@/store/$uv.mixin.js");
Vue.mixin(vuexStore);

import store from '@/store';

import uvUI from '@/uni_modules/uv-ui-tools'
Vue.use(uvUI)

import { Request } from '@/common/utils/request/index';

import Vue from 'vue'
import './uni.promisify.adaptor'
Vue.config.productionTip = false
App.mpType = 'app'

try {
	function isPromise(obj) {
		return (!!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function');
	}
	
	// 统一 vue2 API Promise 化返回格式与 vue3 保持一致
	uni.addInterceptor({
		returnValue(res) {
			if (!isPromise(res)) {
				return res;
			}
			return new Promise((resolve, reject) => {
				res.then((res) => {
					if (res[0]) {
						reject(res[0]);
					} else {
						resolve(res[1]);
					}
				});
			});
		},
	});
} catch (error) {
	console.log('mian.js', error);
}

const app = new Vue({
	store,
	...App
});
Request(app);
//app.$mount()



	RouterMount(app,router,'#app')




